import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class FactsService {
    constructor(private readonly datatask: DataTaskService) {}

    /** @datatask 2920 */
    public async getFacts(params: FactsParams): Promise<FactsGet> {
        return (await this.datatask.Post(2920, params))[0];
    }

    /** @datatask 2921 */
    public listValueTypes(): Promise<FactsValueType[]> {
        return this.datatask.Post(2921, {});
    }

    /** @datatask 2922 */
    public async saveFacts(page: FactsGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2922, page))[0];
    }

    /** @datatask 2923 */
    public async deleteFacts(page: FactsGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2923, page))[0];
    }
}

export interface FactsParams { facts_id: string; }

export interface FactsGet {
    facts_id: string | number;
    facts_name: string;
    sortorder: string | number;
    valuetype_no: string | number;
    isnew: '0' | '1';
}

export interface FactsValueType {
    valuetype_no: string | number;
    valuetype_name: string;
    orderby: string | number;
}
